/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import { ccEnum } from "../CCEnum";
import ReferencedComponent from "./ComponentReference/ReferencedComponent";

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Component which represent a keybaord key shortcut. */
@cc._decorator.ccclass
export default class KeyShortcutComponent extends ReferencedComponent
{
    /** Keyboard key. */
    @property({ type: ccEnum.ccKEY, visible: true })
    protected _key: cc.KEY = cc.KEY.escape;
    /** Public getter for keyboard key. */
    public get Key(): cc.KEY { return this._key; }
    public set Key(value: cc.KEY) { this._key = value; }
}
